import React from 'react'
import { Pressable, ScrollView } from 'react-native'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { ButtonsContainer, CloseContainer, CompactContainerStyles } from '../styled'
import { ModalContentProps } from '../types'

export const CompactModalContent = ({
  actionButtonProps,
  children,
  title,
  testID,
  onClose,
}: ModalContentProps) => {
  return (
    <CompactContainerStyles testID={testID}>
      <CloseContainer
        display='flex'
        flexDirection='row'
        justifyContent='space-between'
        align='flex-start'
        padding={{ top: 'md', left: 'md', right: 'md' }}
      >
        {!!title && (
          <Text fontSize='sm' fontWeight='bold'>
            {title}
          </Text>
        )}
        <Pressable onPress={onClose}>
          <Icon name='x' color='text' />
        </Pressable>
      </CloseContainer>
      <ScrollView>
        <Box padding='md'>{children}</Box>
      </ScrollView>
      {!!actionButtonProps && (
        <ButtonsContainer
          display='flex'
          justifyContent='space-around'
          align='center'
          flexDirection='row'
          padding={{ horizontal: 'md', vertical: 'md' }}
        >
          {actionButtonProps.map((buttonProps) => (
            <Box flex={1} key={buttonProps.title} maxWidth='50%' margin={{ horizontal: 'md' }}>
              <Button borderRadius='sm' {...buttonProps} padding='sm' />
            </Box>
          ))}
        </ButtonsContainer>
      )}
    </CompactContainerStyles>
  )
}
